import { AppNS } from "app";
import axios, { Canceler } from 'axios';
import { API_URL } from '../../core/config';

const CancelToken = axios.CancelToken;
let cancel: Canceler;

export function apiGetJobChanges(
  jobId: string,
  perPage: number = 20,
): Promise<AppNS.JobChange[]> {
  if (cancel !== undefined) {
    cancel();
  }
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}/job-changes.json`, {
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        }),
        params: {
          job_id: jobId,
          per_page: perPage,
        },
      })
      .then(({ data }) => {
        if (data.results) {
          resolve(data.results);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}
